import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import ExternalLink from 'components/atoms/ExternalLink/ExternalLink';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import NoSurveysImage from './assets/no-surveys.svg';
import classes from './NoSurveys.module.scss';
import { REWARDS } from 'components/pages/pages';

export type Props = {};

export default function NoSurveys({}: Props): JSX.Element {
  return (
    <div className={classes.root}>
      <div className={classes.message}>
        <Heading level={3}>You Have No Surveys Available</Heading>

        <Txt component="p">
          Now that you are here, why not go and check out other experiences waiting for you in the{' '}
          <ExternalLink href="#" link="community">
            LifePoints Community
          </ExternalLink>
          .
        </Txt>

        <Txt component="p">
          You can also review your points history or shop our rewards catalog to{' '}
          <A href={REWARDS.path}>redeem your LPs</A>.
        </Txt>

        <Button component={ExternalLink} link="community" href="#" buttonSize="large">
          <Txt>VISIT COMMUNITY</Txt>
        </Button>
      </div>
      <NoSurveysImage className={classes.image} />
    </div>
  );
}
